"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProviderReferred = exports.assertEventType = void 0;
/**
 * Function that asserts that a given event matches one of the included types.
 * Throws an error if the event type does not match.
 * @param {TE} event an event or object returned from an event
 * @param {...TType} eventTypes list of acceptable event types
 *
 */
function assertEventType(event, ...eventTypes) {
    if (!eventTypes.includes(event.type)) {
        throw new Error(`Invalid event: expected one of ["${eventTypes.join('", "')}"], got "${event.type}"`);
    }
}
exports.assertEventType = assertEventType;
const isProviderReferred = (referableProvider, referrals) => {
    return (referrals.findIndex(({ provider, location }) => provider.id === referableProvider.provider.id &&
        (location === null || location === void 0 ? void 0 : location.id) === referableProvider.location.id) !== -1);
};
exports.isProviderReferred = isProviderReferred;
//# sourceMappingURL=util.js.map